"use strict";
/**
 * These types have been directly copied from the @ethersproject/abi package
 */
Object.defineProperty(exports, "__esModule", { value: true });
